export class SecretSystem {
  private readonly discovered = new Set<string>();

  public discover(id = "default"): boolean {
    if (this.discovered.has(id)) return false;
    this.discovered.add(id);
    return true;
  }

  public get isDiscovered(): boolean {
    return this.discovered.size > 0;
  }
}
